/* TODO(developer): Refactor this file to lower the cyclomatic complexity */
/* tslint:disable:cyclomatic-complexity */

import { observable, action, computed } from "mobx";
import { RacingEventInfo, RacingRegionInfo, RacingMasterEventInfo, RacingEventStatus, RacingEventStatusType } from "../models";
import { LeagueInfo, BranchInfo, ArrayHelper, initPolyfills } from "sb-resp-lib";
import { Parser } from "../parsers";

initPolyfills();
export enum RacingEventTypes {
    RaceCard = 341,
    TrapMarket = 760,
    BettingWithoutFav = 767,
    PlaceOnly = 768,
    MatchBetting = 769,
    BettingWithoutTwoFav = 770,
    AUHRPlaceOnly = 784,
    AUHRTote = 785,
    AUHRTotePlaceOnly = 786
};
export enum PushMessageTypes {
    Odds = "OddsMessage",
    Sogei = "SogeiID",
    UserBets = "UserBets",
}

export enum BranchViewEventsType {
    TodaysEvents = 0,
    TomorrowEvents = 1,
    FutureEvents = 2
}

export type PageMethodsComposite = { pageMethods: PageMethods, racingPageMethods: RacingPageMethods };
export type UtilsComposite = { betSlipUtil: BetSlipUtil, oddsUtil: Odds, facade: Facade };

export class RacingStore {
    private name = "RacingStore";
    private static instance: RacingStore;
    private webMethodsComposite!: PageMethodsComposite;
    private facade!: Facade;
    private eventsToUpdate: PushFacadeElements[];
    private updateRacingDataTimeout: any;
    private updateEventsTimeout: any;
    private updateRaceProgressTimeout: any;
    private eventsManager: EventsManager;

    appNavigation: any;
    nextRacesCount: number = 0;
    branchId: number = 0;

    @observable regionId: number = 0;
    @observable todaysEvents: RacingMasterEventInfo[];
    @observable tomorrowEvents: RacingMasterEventInfo[];
    @observable antepostEvents: RacingEventInfo[];
    @observable oddstyleChaged: boolean;
    @observable leagues: LeagueInfo[];
    @observable branch!: BranchInfo;
    @observable regions: RacingRegionInfo[];
    @observable isDataLoading: boolean;

    constructor() {
        this.webMethodsComposite;
        this.facade;

        this.todaysEvents = [];
        this.tomorrowEvents = [];
        this.antepostEvents = [];
        this.regions = [];
        this.leagues = [];
        this.eventsToUpdate = [];
        this.eventsManager = new EventsManager();
        this.oddstyleChaged = false;
        this.getRacingBranchData = this.getRacingBranchData.bind(this);
        this.updateEvents = this.updateEvents.bind(this);
        this.setUpdateRaceProgress = this.setUpdateRaceProgress.bind(this);
        this.resolveUpdateEvents = this.resolveUpdateEvents.bind(this);
        this.subscribeToPush = this.subscribeToPush.bind(this);
        this.isDataLoading = true;
    }

    get webMethods(): PageMethodsComposite {
        return this.webMethodsComposite;
    }

    set webMethods(webMethods: PageMethodsComposite) {
        if (typeof this.webMethodsComposite === "undefined") {
            this.webMethodsComposite = webMethods;
        }
    }

    setFacade(facade: Facade) {
        if (typeof this.facade === "undefined" && facade) {
            this.facade = facade;
            this.facade.addSubscriber(this.subscribeToPush, this.name, PushMessageTypes.Odds, { SubscriberEvents: this.eventsToUpdate, IsBetSlip: false })
        }
    }

    subscribeToPush(data: any[]) {
        let events: RacingEventInfo[] = ArrayHelper.ArrayOf(data, Parser.RacingEventParseUpdateEvents.bind(Parser));
        this.updateStore(events);

        if (this.facade) {
            this.facade.clearDebounce(this.name);
        }
    }

    public static get getInstance(): RacingStore {
        return this.instance || (this.instance = new this());
    }

    /* istanbul ignore next */
    setUpdateRacingData() {
        this.updateRacingDataTimeout = setTimeout(this.getRacingBranchData, 60 * 1000);
    }

    setUpdateEventsData() {
        this.updateEventsTimeout = setTimeout(this.updateEvents, 15 * 1000);
    }

    setUpdateRaceProgressData() {
        this.updateRaceProgressTimeout = setTimeout(this.setUpdateRaceProgress, 10 * 1000);
    }

    getRacingBranchData() {
        if (this.webMethods) {
            this.webMethods.racingPageMethods.GetRacingBranchData(
                this.regionId,
                this.branchId,
                this.resolveRacingBranchData,
                this.rejectRacingBranchData);
        }
    }

    @action.bound resolveRaceProgress(response) {
        let data = eval(response);
        for (let item of data) {
            let masterEvent = this.todaysEvents.find((x) => x.id === item[0].toString());
            if (!masterEvent) {
                continue;
            }

            masterEvent.raceProgress = item[2];
            for (let j = 0, ar = masterEvent.racingEvents; j < ar.length; j++) {
                let ev = ar[j];
                ev.raceProgress = item[2];
            }
        }

        this.setUpdateRaceProgressData();
    }

    setUpdateRaceProgress() {

        let nextRaces = this.todaysEvents.concat(this.tomorrowEvents);
        nextRaces = this.sortEventByDate(nextRaces);

        let evCount = 0;
        let evArray: string[] = [];
        for (let i = 0; i < nextRaces.length; i += 1) {
            let masterEvent = nextRaces[i];

            if (evCount === 3) { break; }
            let isRaceCardFound = false;

            if (masterEvent.raceProgress === 2) { continue; }

            for (let j = 0; j < masterEvent.racingEvents.length; j += 1) {
                let ev = masterEvent.racingEvents[j];

                if (parseInt(ev.typeId) !== RacingEventTypes.RaceCard) { continue; }
                isRaceCardFound = true;
                evArray.push(ev.id);
            }
            evCount += isRaceCardFound && this.isEventOpen(masterEvent) ? 1 : 0;
        }
        this.webMethods.racingPageMethods.GetRacingProgress(
            evArray.join("@"),
            this.resolveRaceProgress,
            this.rejectRacingBranchData)
    }

    @action.bound resolveRacingBranchData(response) {

        let data = eval(response);

        if (data && data.length > 0) {
            this.leagues = ArrayHelper.ArrayOf(data[0], Parser.LeagueParse.bind(Parser));
            this.todaysEvents = ArrayHelper.ArrayOf(data[1], Parser.RacingMasterEventParse.bind(Parser));
            this.tomorrowEvents = ArrayHelper.ArrayOf(data[3], Parser.RacingMasterEventParse.bind(Parser));
            this.antepostEvents = ArrayHelper.ArrayOf(data[2], Parser.RacingEventParse.bind(Parser));
        }

        this.isDataLoading = false;

        this.updateEvents();
    }

    getMasterEventSpecificEventType(masterEvent: RacingMasterEventInfo, eventTypeId: number): number {
        let event: any;
        if (masterEvent.racingEvents) {
            event = masterEvent.racingEvents.find((ev) => {
                return parseInt(ev.typeId) === eventTypeId || ev.raceProgress === 2;
            });
        }
        return event ? event.id : 0;
    }

    updateEvents() {
        let nextRaces = this.todaysEvents.concat(this.tomorrowEvents);
        nextRaces = this.sortEventByDate(nextRaces);
        let nextRacesAr: any[] = [];
        let evCount = 0;
        this.eventsToUpdate = [];

        for (let i = 0; i < nextRaces.length; i += 1) {

            for (let j = 0; j < nextRaces[i].racingEvents.length; j++) {
                let ev = nextRaces[i].racingEvents[j];

                if (ev.raceProgress !== 0 || parseInt(ev.typeId) !== RacingEventTypes.RaceCard) { continue; }

                if (evCount === this.nextRacesCount) { break; }

                nextRacesAr.push(ev.id);
                this.eventsToUpdate[ev.id] = {
                    ID: ev.id,
                    updateString: ev.id.toString(),
                    /* istanbul ignore next */
                    getUpdateString(): string {
                        /* istanbul ignore next */
                        return this.updateString;
                    }
                };

                evCount += 1;
            }
        }

        if (this.webMethods) {
            this.webMethods.pageMethods.UpdateEvents(
                nextRacesAr.join("@"),
                this.resolveUpdateEvents,
                this.rejectUpdateEvents)
        }
    }

    @action.bound rejectRacingBranchData(error) {
        this.isDataLoading = false;
    }

    @action.bound rejectUpdateEvents(error) {
        this.setUpdateEventsData();
    }

    @computed get isTomorrowEventsPresent() {
        return !this.isDataLoading && this.tomorrowEvents.length > 0;
    }

    @computed get isTodayEventsPresent() {
        return this.isDataLoading || this.todaysEvents.length > 0;
    }

    @computed get isFutureEventsPresent() {
        return !this.isDataLoading && this.antepostEvents.length > 0;
    }

    isEventOpen(event: RacingMasterEventInfo) {
        return event.raceProgress === 0;
    }

    @computed get isNextRacesAvailable() {
        return this.isDataLoading ||
            (
                this.todaysEvents.length > 0 &&
                this.todaysEvents.some(this.isEventOpen)
            )
            ||
            (
                this.tomorrowEvents.length > 0 &&
                this.tomorrowEvents.some(this.isEventOpen)
            );
    }

    @action updateStore(events: RacingEventInfo[]) {
        let eventsKeys = Object.keys(events);
        let allMasterEvents = this.todaysEvents.concat(this.tomorrowEvents);

        for (let index = 0; index < eventsKeys.length; index++) {
            let event = events[eventsKeys[index]];
            let masterEvent = allMasterEvents.find(
                /* istanbul ignore next */
                mEv => mEv.id === this.getMasterEventID(event)
            );

            if (!masterEvent) { continue; }

            /* istanbul ignore next */
            if (masterEvent.racingEvents) {
                let oldEvent = masterEvent.racingEvents.find(
                    /* istanbul ignore next */
                    ev => ev.id === event.id
                );

                /* istanbul ignore next */
                if (typeof (oldEvent) !== "undefined") {
                    oldEvent.racingStateId = event.racingStateId;
                    oldEvent.lines = event.lines;
                    oldEvent.racecardLines = event.racecardLines;
                }
            }
        }
    }

    @action.bound resolveUpdateRegionAndBranch(response) {
        let data = JSON.parse(response);
        this.branch = Parser.BranchParse(data.Branch);
        this.regions = ArrayHelper.ArrayOf(data.Regions, Parser.RegionParse.bind(Parser));
        this.regionId = this.regionId ? this.regionId : this.regions[0].id;
        this.getRacingBranchData();
    }

    resolveUpdateEvents(response) {
        let data = eval(response);
        let events: RacingEventInfo[] = ArrayHelper.ArrayOf(data, Parser.RacingEventParseUpdateEvents.bind(Parser));
        this.updateStore(events);
        this.setUpdateEventsData();
    }

    getMasterEventID(event: RacingEventInfo): string {
        return event.id.toString();
    }

    getRegionsAndBranch() {
        if (this.webMethods) {
            this.webMethods.racingPageMethods.GetRacingBranchAndRegions(
                this.branchId,
                this.resolveUpdateRegionAndBranch,
                this.rejectRacingBranchData)
        }
    }

    @action setRegion(value: number) {
        this.regionId = value;
        this.clear();
        this.getRacingBranchData();
    }

    @action setParams(regionId: number, branchId: number) {
        this.regionId = regionId;
        this.branchId = branchId;

        this.getRegionsAndBranch();
        this.setUpdateRaceProgressData();
        this.eventsManager.addEventListener("oddStyleChanged", this, this.changingOddsStyle, true);
    }

    @action changingOddsStyle() {
        this.oddstyleChaged = !this.oddstyleChaged;
    }

    filteredEventsByLeagueID(racingEventsType: number, masterLeagueID: string) {

        let events = racingEventsType === 0 ? this.todaysEvents : this.tomorrowEvents;
        let filteredEvents = events.filter(ev => ev.masterLeagueId === masterLeagueID);

        return this.sortEventByDate(filteredEvents);
    }

    sortEventByDate(events: RacingMasterEventInfo[]) {
        events.sort(this.compareByDate);
        return events;
    }

    @computed get sortedLeagues() {
        let sortedLeagues = this.leagues.sort(this.compareLeagues)
        return sortedLeagues;
    }

    @computed get sortedAntepostEvents() {
        let antepostEvents = this.antepostEvents.sort(this.compareByDate)
        return antepostEvents;
    }

    compareByDate(e1, e2) {
        if (e1.date > e2.date) {
            return 1;
        }
        else if (e1.date < e2.date) {
            return -1;
        }
        return 0;
    }

    @action clear() {
        this.todaysEvents = [];
        this.tomorrowEvents = [];
        this.antepostEvents = [];
        this.leagues = [];
        this.isDataLoading = true;

        clearTimeout(this.updateEventsTimeout);
        clearTimeout(this.updateRacingDataTimeout);
        clearTimeout(this.updateRaceProgressTimeout);
    }

    /* istanbul ignore next */
    compareLeagues(l1: LeagueInfo, l2: LeagueInfo) {
        /* istanbul ignore next */
        if (l1.sortId > l2.sortId) {
            return 1;
        }
        /* istanbul ignore next */
        else if (l1.sortId < l2.sortId) {
            return -1;
        }

        /* istanbul ignore next */
        if (l1.name > l2.name) {
            return 1;
        }
        else if (l1.name < l2.name) {
            return - 1;
        }
        return 0;
    }

    getEventStatus(raceProgress: number): RacingEventStatus {
        return {
            isNotStarted: raceProgress === RacingEventStatusType.IsNotStarted,
            isRaceOff: raceProgress === RacingEventStatusType.IsRaceOff,
            isResult: raceProgress === RacingEventStatusType.IsResult,
            isOver: raceProgress === RacingEventStatusType.IsOver
        }
    }

    getMasterRacingEventUrl(racingEvent: RacingMasterEventInfo, league: LeagueInfo): string {
        let resultUrl = "";

        if (racingEvent && league) {
            resultUrl = this.getEventUrl(league.urlCode, racingEvent.url);
        }

        return resultUrl;
    }

    getRacingEventUrl(racingEventUrl: string, leagueId: string): string {
        let resultUrl = "",
            league = this.leagues.find((x) => x.id === leagueId);

        if (league) {
            resultUrl = this.getEventUrl(league.urlCode, racingEventUrl);
        }
        return resultUrl;
    }

    private getEventUrl(leagueCode: string, racingEventUrl: string): string {
        let branchCode = this.branch.code,
            resultUrl = branchCode ? branchCode : "";

        if (racingEventUrl && leagueCode) {
            resultUrl = `${resultUrl}/${leagueCode}/${racingEventUrl}`;
        }
        resultUrl = this.appNavigation.adjustSportsPath(resultUrl);
        return resultUrl;
    }

    deactivate() {
        this.eventsManager.removeEventListener("oddStyleChanged", this, true);
    }

    subscribe() {

    }

    unsubscribe() {

    }
}
